// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import ScreenTitle from 'components/ScreenTitle';
import Header from 'components/Header';
import Footer from 'components/Footer';

const ContractJobLayout = ({ children }) => {

	return (
		<div className='ContractJobLayout'>
			
			<Header/>

			<Container>

				<ScreenTitle title='Contract Job'/>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

ContractJobLayout.propTypes = {
	children: PropTypes.node,
	title: PropTypes.string
}

ContractJobLayout.defaultProps = {
	children: null,
	title: ''
}

export default ContractJobLayout